import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';
import { environment } from '../../../environments/environment';
import * as _logger from '../../services/logger';
import { resx } from '../../services/config';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-signin-oidc',
    templateUrl: './signin-oidc.component.html',
    styleUrls: ['./signin-oidc.component.css']
})
export class SigninOidcComponent implements OnInit {
    constructor(private oidcService: OpenIdConnectService, private router: Router, private toastr: ToastrService) {
    }

    ngOnInit() {
        this.oidcService.userLoaded$.subscribe((userLoaded) => {
            if (userLoaded) {

                // Get path to redirect to
                var redirect = localStorage.getItem(this.oidcService.redirectKey);
                if (!redirect) {
                    redirect = "/";
                } else {
                    localStorage.removeItem(this.oidcService.redirectKey);
                }

                this.router.navigate([redirect]).then(() => {
                    $('.app-loading-shell').addClass('finished-loading');

                    _logger.log(resx.toasts.welcomeMsg.replace('{0}', this.oidcService.profile.name), null, null, true, this.toastr);
                });
            } else {
                if (!environment.production) {
                    console.log("Error: user not loaded");
                }
            }
        })

        this.oidcService.handleCallback();
    }

}
